
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/comUpwardStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "cmd": "reportParkSpecialCarTypeConfig"
  
        },
        responseCode: {
          "data": {},
          "message": "业务成功",
          "resultCode": 0,
          "status": 1
        },
        infoData: {
          explain: "智慧停车开放平台主动上报车场特殊车辆类型信息到第三方接入系统",
          urlPattern: this.commonUrls.third + "reportParkSpecialCarTypeConfig",
          precondition: "无",
          fitSystem: "云停车场",
          pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
          frequency: "实时触发",
          Q_params: [{
            titleName: null,
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'
            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: [{
                info1: 'id',
                info2: '是',
                info3: 'Long',
                info4: '特殊车辆类型id'
              },
              {
                info1: 'createTime',
                info2: '是',
                info3: 'String',
                info4: '创建时间(yyyMMddHHmmss)'
              },   {
                info1: 'updateTime',
                info2: '是',
                info3: 'String',
                info4: '更新时间(yyyMMddHHmmss)'
              },
              {
                info1: 'parkDataList',
                info2: '是',
                info3: 'JsonArray',
                info4: '新适用车场列表。'
              },
              {
                info1: 'parkDataListOld',
                info2: '是',
                info3: 'JsonArray',
                info4: '旧适用车场列表。'
              },
              {
                info1: 'vipGroupType',
                info2: '是',
                info3: 'Integer',
                info4: '0-普通vip 1-访客vip 2-黑名单vip，3预定vip，4共享vip。'
              },
              {
                info1: 'isDelete',
                info2: '是',
                info3: 'Integer',
                info4: '是否删除，0否，1是'
              },{
                info1: 'channelDataListNew',
                info2: '是',
                info3: 'JsonArray',
                info4: '新适用通道列表。'
              },
            ]
          }, {
            titleName: 'reportChannelChangeEntityList',
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'
            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: [{
                info1: 'customCode',
                info2: '是',
                info3: 'String',
                info4: '自定义通道编码'
              },
              {
                info1: 'enable',
                info2: '是',
                info3: 'String',
                info4: '通道状态 启用禁用'
              },
              {
                info1: 'entranceType',
                info2: '是',
                info3: 'Integer',
                info4: '通道类型'
              },
              {
                info1: 'normalCarPassMode',
                info2: '是',
                info3: 'Integer',
                info4: '临时车放行模式'
              },
              {
                info1: 'normalNoRecordPassMode',
                info2: '是',
                info3: 'String',
                info4: '临时车无在场放行模式'
              },
              {
                info1: 'localVipCarPassMode',
                info2: '否',
                info3: 'String',
                info4: '本地VIP车辆进场模式'
              },
              {
                info1: 'blacklistPassMode',
                info2: '否',
                info3: 'Decimal',
                info4: '黑名单通行模式'
              },
              {
                info1: 'redListPassMode',
                info2: '否',
                info3: 'String',
                info4: '红/白名单通行模式'
              },
              {
                info1: 'visitorListPassMode',
                info2: '否',
                info3: 'String',
                info4: '访客通行模式'
              },
              {
                info1: 'noPlatePassMode',
                info2: '否',
                info3: 'String',
                info4: '无牌车通行模式'
              },
              {
                info1: 'parkName',
                info2: '否',
                info3: 'String',
                info4: '车场名称'
              }
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'
            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: []
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{
              tableHead: '状态码',
              tdName: 'info1'
            }, {
              tableHead: '说明',
              tdName: 'info2'
            }],
            td: []
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportParkSpecialCarTypeConfig.vue